<template>
  <header class="app-header"><a class="app-header__logo" href="#"><small>{{ app.name_en }}</small></a>
    <!-- Sidebar toggle button--><a class="app-sidebar__toggle" href="#" data-toggle="sidebar"
      aria-label="Hide Sidebar"></a>
    <!-- Navbar Right Menu-->
    <ul class="app-nav">
      <!--Notification Menu-->
      <li class="dropdown"><a class="app-nav__item" href="#" data-bs-toggle="dropdown"
          aria-label="Show notifications"><i class="bi bi-bell fs-5"></i></a>
        <ul class="app-notification dropdown-menu dropdown-menu-right">
          <li class="app-notification__title">คุณมีการแจ้งเตือนใหม่ 0 รายการ</li>
          <div class="app-notification__content">
            <li><a class="app-notification__item" href="javascript:;"><span class="app-notification__icon"><i
                    class="bi bi-envelope fs-4 text-primary"></i></span>
                <div>
                  <p class="app-notification__message">คุณมีการแจ้งเตือนใหม่</p>
                  <p class="app-notification__meta">1 นาทีที่แล้ว</p>
                </div>
              </a></li>
          </div>
          <li class="app-notification__footer"><a href="#">ดูการแจ้งเตือนทั้งหมด</a></li>
        </ul>
      </li>
      <!-- User Menu-->
      <li class="dropdown"><a class="app-nav__item" href="#" data-bs-toggle="dropdown" aria-label="Open Profile Menu"><i
            class="bi bi-person fs-4"></i></a>
        <ul class="dropdown-menu settings-menu dropdown-menu-right">
          <!-- <li><a class="dropdown-item" href="#"><i class="bi bi-gear me-2 fs-5"></i> การตั้งค่า</a>
          </li> -->
          <li>
            <router-link :to="{ name: 'profile' }" class="dropdown-item">
              <i class="bi bi-person me-2 fs-5"></i>
              ข้อมูลส่วนตัว
            </router-link>
          </li>
          <li><a @click="logout" class="dropdown-item" href="#"><i class="bi bi-box-arrow-right me-2 fs-5"></i>
              ออกจากระบบ</a></li>
        </ul>
      </li>
    </ul>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  methods: {
    logout() {
      this.$store.dispatch('logout');
    }
  },
  computed: {
    ...mapState(['app']),
    user() {
      return this.$store.getters.user;
    }
  }
}
</script>

<style scoped>
.app-header__logo {
  font-size: 21px;
}
</style>